import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsFieldsRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-fields',
	path: '/plugins/servlet/project-config/:projectKey/fields',
};
